import { Select } from "@tfg/ui"
import { forwardRef } from "react"

import { LANGUAGES } from "~/utils/languages.tsx"

type Props = Omit<React.ComponentProps<typeof Select>, "data">

export const LanguageSelector = forwardRef<HTMLInputElement, Props>(
  (props, ref) => {
    return (
      <Select
        ref={ref}
        searchable
        data={Object.entries(LANGUAGES).map(([code, lang]) => ({
          label: lang.languageName,
          value: code,
        }))}
        disabled={props.disabled}
        {...props}
      />
    )
  }
)
